var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgDeliveryHand = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M25.117 12.016v39.713h53.897V13.428c0-1.915-1.48-3.427-3.356-3.427H27.091c-1.086 0-1.974.907-1.974 2.016Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M60.357 19.105H45.33c-.72 0-1.235-.512-1.235-1.228V10h16.674v8.593c.103.307-.103.512-.412.512Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M29.605 39.612h2.879M34.867 39.612h2.978M40.228 39.612h2.979"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "m38.781 43.763 5.314 3.035h27.328l7.06-3.035-7.06 8.346-6.832 1.517L48.27 52.11l-9.489-8.346Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M83.217 39.915c-3.574.807-6.652 3.027-9.034 7.769l-7.943 4.54c-.894-1.21-2.383-2.118-4.468-2.118H50.355c-1.688 0-5.163-4.44-7.844-4.44-.993-.404-5.957-.404-9.432 0-2.68 0-6.155 2.422-8.141 4.238-2.979 3.027-10.623 10.392-11.517 11.099 4.865 4.136 14.793 13.823 16.978 15.84 2.978-3.026 4.17-5.851 6.552-5.851h26.807c2.184 0 14.396-11.301 15.985-13.117 1.133-1.306 6.009-7.702 9.104-12.594.97-1.533.795-2.656.415-3.794-1.092-1.614-2.272-2.48-6.045-1.572Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M83.217 39.915c-3.574.807-6.652 3.027-9.034 7.769l-7.943 4.54c-.894-1.21-2.383-2.118-4.468-2.118H50.355c-1.688 0-5.163-4.44-7.844-4.44-.993-.404-5.957-.404-9.432 0-2.68 0-6.155 2.422-8.141 4.238-2.979 3.027-10.623 10.392-11.517 11.099 4.865 4.136 4.197-2.018 6.381 0 2.406-2.445 9.891-11.1 13.277-11.1 2.286-1.208 4.183-1.208 7.6-1.208.238-.274 6.381 5.334 9.676 5.311 4.912-.033 10.08 1.919 16.513.759.945-1.511 3.789-.705 9.869-5.037.759-2.93 6.073-5.965 6.48-5.585 3.273-1.134 5.112 1.956 5.63 1.138.97-1.533.795-2.656.415-3.794-1.092-1.614-2.272-2.48-6.045-1.572Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M45.688 60.498h16.084c7.347 0 7.347-10.393 0-10.393H50.355c-1.688 0-4.964-4.44-7.645-4.44H32.484c-2.88 0-5.56 2.422-7.447 4.238-2.978 3.027-10.623 10.393-11.516 11.1 4.765 4.136 14.694 13.822 16.878 15.84 2.978-3.026 4.17-5.852 6.552-5.852h24.722c1.986 0 3.872-.504 5.66-1.412 5.658-3.23 11.119-10.191 12.41-11.604 1.092-1.311 5.957-7.567 9.034-12.511 1.688-2.623-.297-6.054-3.375-5.852-.695.1-1.49.202-2.284.403-3.574.808-6.652 3.027-9.035 7.77l-7.942 3.935"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m29.009 85.016 5.361-5.449c1.29-1.311 1.29-3.33 0-4.64l-17.474-17.86c-1.29-1.312-3.276-1.312-4.567 0l-5.361 5.449c-1.29 1.311-1.29 3.33 0 4.641l17.573 17.86a3.028 3.028 0 0 0 4.468 0Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m12.826 63.424 3.872 3.935"
  }));
};
export default SvgDeliveryHand;